import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_VIEW, VIEW_VALUES, type View } from '../constants';

function readUrl() {
  const params = new URLSearchParams(location.search);
  const raw = params.get('view');
  return {
    view: VIEW_VALUES.includes(raw as View) ? (raw as View) : DEFAULT_VIEW,
    reportId: params.get('report_id') || undefined
  };
}

export function useUrlView() {
  const [state, setState] = useState(readUrl);
  useEffect(() => {
    const handlePop = () => setState(readUrl());
    addEventListener('popstate', handlePop);
    return () => removeEventListener('popstate', handlePop);
  }, []);
  const navigate = useCallback((view: View, reportId?: string, replace = false) => {
    const url = new URL(location.href);
    url.searchParams.set('view', view);
    if (view === 'reports' && reportId) url.searchParams.set('report_id', reportId);
    else url.searchParams.delete('report_id');
    history[replace ? 'replaceState' : 'pushState']({}, '', url);
    setState({ view, reportId: view === 'reports' ? reportId : undefined });
  }, []);
  return { ...state, navigate };
}
